import { getElectronAPI } from "@/plugins/desktop";
import ApiOfflineService from "./ApiOfflineService";
import ConfiguracaoGeralPdvDesktopService from "./ConfiguracaoGeralPdvDesktopService";
import PdvDesktopAuthService from "./PdvDesktopAuthService";

const PdvDesktopAdminAuthorizationService = {
  async deveSolicitarSenha() {
    const [config, usuario] = await Promise.all([
      ConfiguracaoGeralPdvDesktopService.carregarLocal(),
      PdvDesktopAuthService.getUsuarioAtual(),
    ]);
    return config.solicita_senha_adm === true && usuario.admin !== true;
  },

  async validarSenha(senha) {
    if (!String(senha || "").trim()) throw new Error("Informe a senha do administrador.");

    if (typeof navigator === "undefined" || navigator.onLine !== false) {
      try {
        const resposta = await ApiOfflineService.post("usuario/check-adm", { password: senha });
        if (resposta?.status === true || resposta?.success === true) return true;
        const negada = new Error(
          resposta?.msg || resposta?.message || "Senha de administrador inválida."
        );
        negada.code = "SENHA_ADM_INVALIDA";
        throw negada;
      } catch (error) {
        if (error?.code === "SENHA_ADM_INVALIDA") throw error;
        const status = error?.response?.status;
        if (status && status < 500 && ![401, 408, 429].includes(status)) throw error;
      }
    }

    const usuario = await PdvDesktopAuthService.getUsuarioAtual();
    const resposta = await getElectronAPI()?.usuarios?.validarAdmin?.(senha, usuario.id_empresa);
    if (resposta?.ok) return true;
    if (resposta?.code === "SEM_ADMIN_CACHE") {
      throw new Error("Nenhum administrador possui credencial offline neste terminal. Conecte à internet ou faça um login online de administrador.");
    }
    throw new Error("Senha de administrador inválida.");
  },

  async solicitarAutorizacao(vm, acao = "realizar esta operação") {
    if (!(await this.deveSolicitarSenha())) return true;

    const result = await vm.$swal.fire({
      title: "Autorização administrativa",
      text: `Informe a senha de um administrador para ${acao}.`,
      input: "password",
      inputPlaceholder: "Senha do administrador",
      showCancelButton: true,
      confirmButtonText: "Autorizar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: async (senha) => {
        try {
          await this.validarSenha(senha);
          return true;
        } catch (error) {
          vm.$swal.showValidationMessage(error?.message || "Não foi possível validar a senha.");
          return false;
        }
      },
    });
    return result.isConfirmed === true;
  },
};

export default PdvDesktopAdminAuthorizationService;
